import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

const Considerapp = () => {
  return (
    <div className="consider_usa p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={5}>
            <div className="consider_content">
              <h2>
                When to Consider Our Custom WordPress Development Services?
              </h2>
              <p>
                Whether building from the ground up or looking to upgrade, we
                guarantee smooth and custom solutions to meet your website
                development requirements. Here’s when you should consider
                signing up for our WordPress development services:
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let's Build Your WordPress website
              </Link>
            </div>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="offset-xl-1">
            <div className="consider-box">
              <h6>Starting Fresh</h6>
              <p>
                If you're launching a new website, our custom WordPress
                development ensures a strong foundation designed to meet your
                needs.
              </p>
            </div>
            <div className="consider-box">
              <h6>Site Enhancement</h6>
              <p>
                When your existing site needs an upgrade, our services provide
                smooth improvements, enhancing functionality and user
                experience.
              </p>
            </div>
            <div className="consider-box">
              <h6>Custom Features</h6>
              <p>
                If you require unique features or functionalities, our team
                specializes in developing custom solutions to make your website
                stand out.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Considerapp;
